import {useEffect, useState} from "react"
import styleConstants from "../constants/styleConstants"

export const useMedia = (query: string) => {
  const [state, setState] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    let mounted = true
    const mql = window.matchMedia(query)

    const onChange = () => {
      if (!mounted) return
      setState(mql.matches)
    }

    mql.addListener(onChange)
    setState(mql.matches)

    return () => {
      mounted = false
      mql.removeListener(onChange)
    }
  }, [query])

  return state
}

const useIsDesktopBreakpoint = (): boolean =>
  useMedia(`(min-width: ${styleConstants.desktopMinWidth})`)

export default useIsDesktopBreakpoint
